<template>
  <div class="section py-0">
    <!-- <pre>
      {{ users }}
    </pre> -->
    <div class="section pb-0">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-gold is-outlined"
            icon-left="plus"
            icon-pack="fas"
            tag="router-link"
            :to="{ name: 'NewUser' }"
          >
            Neuer Nutzer
          </b-button>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon-pack="fas"
              icon="search"
            >
            </b-input>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-select v-model="rangeRows" placeholder="Select a name">
              <option value="20">20 pro Seite</option>
              <option value="50">50 pro Seite</option>
              <option value="100">100 pro Seite</option>
              <option value="500">500 pro Seite</option>
            </b-select>
          </b-field>
        </div>
        <!-- <div class="column is-narrow">
          <b-dropdown
            :triggers="['hover']"
            aria-role="list"
            position="is-bottom-left"
          >
            <template #trigger>
              <b-button type="is-gold is-outlined" icon-right="caret-down">
                Aktionen
              </b-button>
            </template>

            <b-dropdown-item
              aria-role="listitem"
              :disabled="checkedRows.length === 0"
              @click="downloadCSV"
            >
              Liste exportieren
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem">
              Another action
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem">
              Something else
            </b-dropdown-item>
          </b-dropdown>
        </div> -->
      </div>
    </div>
    <div class="section">
      <b-table
        :data="filteredUsers"
        :loading="loadingUsers"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        :paginated="filteredUsers.length > 20"
        :per-page="rangeRows"
        sort-icon="arrow-up"
        default-sort="users.id"
        striped
        hoverable
      >
        <b-table-column
          field="last_name"
          label="Nachname"
          sortable
          v-slot="props"
        >
          {{ props.row.last_name }}
        </b-table-column>

        <b-table-column
          field="first_name"
          label="Vorname"
          sortable
          v-slot="props"
        >
          {{ props.row.first_name }}
        </b-table-column>

        <b-table-column field="email" label="Email" sortable v-slot="props">
          {{ props.row.email }}
        </b-table-column>

        <b-table-column
          field="org_id"
          label="Organization"
          sortable
          v-slot="props"
        >
          <template v-if="!loadingOrgs">
            {{ orgById(props.row.org_id).name }}
          </template>
        </b-table-column>

        <b-table-column field="user_type" label="Rolle" sortable v-slot="props">
          <userTag :data="props.row.type" />
        </b-table-column>

        <b-table-column field="products" label="Produkte" v-slot="props">
          <template v-if="!loadingProducts">
            <iconRow :data="props.row.products_subscribed" />
          </template>
        </b-table-column>

        <b-table-column field="expires_at" label="Laufzeit" v-slot="props">
          <span v-if="props.row.expires_at">
            {{ new Date(props.row.expires_at).toLocaleDateString("de-DE") }}
          </span>
          <span v-else> --- </span>
        </b-table-column>

        <b-table-column
          field="activated"
          label="Aktiviert"
          width="40"
          sortable
          v-slot="props"
        >
          <b-icon
            v-if="props.row.activated"
            type="is-success"
            icon-pack="fas"
            icon="circle"
          ></b-icon>
          <b-icon
            v-else
            type="is-danger"
            icon-pack="fas"
            icon="circle"
          ></b-icon>
        </b-table-column>

        <b-table-column
          v-if="'comment' in users[0]"
          field="comment"
          label="Kommentar"
          v-slot="props"
        >
          <b-tooltip
            v-if="isTooLong(props.row.comment, 33)"
            :label="props.row.comment"
            :position="commentTooltipPos(props.row.id)"
            size="is-large"
            type="is-gold is-light"
            multilined
          >
            {{ truncate(props.row.comment, 33) }}
          </b-tooltip>
          <span v-else>{{ props.row.comment }}</span>
        </b-table-column>

        <b-table-column field="action" label="" width="40" v-slot="props">
          <router-link
            :to="{ name: 'ViewUser', params: { userId: props.row.id } }"
          >
            <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
          </router-link>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import iconRow from '@/components/helper/IconRow.vue';
import userTag from '@/components/editUser/UserTag.vue';
import helper from '@/functions/helper';

export default {
  name: 'AllUser',
  components: {
    iconRow,
    userTag,
  },
  data() {
    return {
      search: '',
      checkedRows: [],
      rangeRows: 20,
    };
  },
  computed: {
    filteredUsers() {
      return helper.search(this.users, ['first_name', 'last_name', 'comment'], this.search);
    },
    ...mapGetters({
      users: 'user/data',
      loadingUsers: 'user/loading',
      orgById: 'org/dataById',
      loadingOrgs: 'org/loading',
      prodById: 'product/dataById',
      loadingProducts: 'product/loading',
    }),
  },
  methods: {
    downloadCSV() {
      let csv = '';

      const header = [
        'ID',
        'Nachname',
        'Vorname',
        'Organisation',
        'Rolle',
        'Produkte',
        'Laufzeit',
        'Komm1entar',
        'Org. Lizenz Typ',
        'Org. Kommentar',
      ];
      csv += `${header.join(',')}\n`;

      this.checkedRows.forEach((row) => {
        const flatRow = [];
        flatRow[0] = row.id; // ID
        flatRow[1] = row.last_name; // Nachname
        flatRow[2] = row.first_name; // Vorname
        flatRow[3] = this.orgById(row.org_id).name; // Organisation
        flatRow[4] = row.user_type; // Rolle
        flatRow[5] = row.products_subscribed.map((item) => this.prodById(item).name).join('; '); // Produkte
        flatRow[6] = new Date(row.expires_at).toLocaleDateString('de-DE'); // Laufzeit
        flatRow[7] = row.comment; // Kommentar
        flatRow[8] = this.orgById(row.org_id).license_type; // Org. Lizenz Typ
        flatRow[9] = this.orgById(row.org_id).comment; // Org. Kommentar

        csv += flatRow.join(',');
        csv += '\n';
      });

      // document.write(csv);

      const hiddenElement = document.createElement('a');
      hiddenElement.href = `data:text/csv;charset-utf-8,${encodeURI(csv)}`;
      hiddenElement.target = '_blank';
      console.log(hiddenElement);

      hiddenElement.download = `Standortmonitor_Nutzer_Liste_${new Date().toLocaleDateString(
        'de-DE',
      )}.csv`;

      hiddenElement.click();
    },
    isTooLong(str, limit) {
      return helper.isTooLong(str, limit);
    },
    truncate(str, limit) {
      return helper.truncate(str, limit);
    },
    commentTooltipPos(id) {
      const index = this.filteredUsers.findIndex((user) => user.id === id);
      return index === 0 ? 'is-bottom' : 'is-top';
    },
  },
};
</script>
